const updateCartOnSucces = function (response) {
  if (response.data.success && response.data.cart) {
    this.commit('update', response.data.cart);
  }

  return response;
};

export const initCartStore = ({cart, endpoints}) => {
  window.App.store.registerModule('cart', {
    namespaced: true,
    state: {
      cart: cart || null,
    },
    mutations: {
      update(state, cart) {
        state.cart = cart;
      },
      toggleGift(state, {id, value}) {
        if (!id) {
          state.cart.group_gifts = value;
        }
        const index = state.cart.items.findIndex(item => item.id === id);
        if (index >= 0) {
          state.cart.items[index].gift = value;
        }
      }
    },
    actions: {
      add(context, {variant_id, quantity}) {
        return window.App.Axios.post(endpoints.add, {
          variant: variant_id,
          quantity: quantity
        }).then(updateCartOnSucces.bind(context));
      },
      remove(context, item) {
        return window.App.Axios.post(endpoints.remove, {
          id: item
        }).then(updateCartOnSucces.bind(context));
      },
      applyCoupon(context, coupon) {
        return window.App.Axios.post(endpoints.applyCoupon, {
          coupon: coupon
        }).then(updateCartOnSucces.bind(context));
      },
      removeCoupon(context, coupon) {
        return window.App.Axios.post(endpoints.removeCoupon, {
          code: coupon
        }).then(updateCartOnSucces.bind(context));
      },
      updateGiftSettings({commit}, {id, active, name}) {
        return window.App.Axios.post(endpoints.saveGiftSettings, {
          [name || 'gift-' + id]: active
        }).then(({data}) => {
          if (data.success) {
            commit('toggleGift', {id: id, value: active});
          }
        });
      }
    }
  });
};

window.App.initCartStore = initCartStore;



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/CartStoreModule.js